import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { toast } from "sonner";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Connexion échouée");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#2C1A14] px-4">
      <div className="w-full max-w-md rounded-2xl bg-[#FBF1EE] p-8 shadow-2xl">
        <div className="mb-8 text-center">
          <img src="/logo-yoyo.png" alt="Le Dressing de Yoyo" className="mx-auto h-36 w-auto" />
          <p className="mt-3 text-sm uppercase tracking-[0.25em] text-[#9B7E73]">Espace administrateur</p>
        </div>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" data-testid="admin-login-email" value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1 bg-white" required />
          </div>
          <div>
            <Label htmlFor="password">Mot de passe</Label>
            <Input id="password" type="password" data-testid="admin-login-password" value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1 bg-white" required />
          </div>
          <Button type="submit" disabled={loading} data-testid="admin-login-submit" className="w-full rounded-full bg-[#D76E4D] py-6 text-white hover:bg-[#C05A3A]">
            {loading ? "Connexion..." : "Se connecter"}
          </Button>
        </form>
      </div>
    </div>
  );
}
